import $axios from "@/utils/axios";
import { keyBy } from "lodash";

/**
 * 董事长门户
 */
export default {
  namespaced: true,
  state: () => ({
    firstTypeTabList: [
      // {
      //   "typeCode": "ZLJZ",
      //   "typeId": "E21E5E8B42BF389AE053DA010A0ACCC8",
      //   "typeName": "治理机制"
      // }
    ], // 一级分类配置，有几个模块都用到了这个配置，在调用接口时会使用到 typeId，前端这边会用 typeCode 来匹配
  }),
  getters: {
    firstTypeTabMap: state => keyBy(state.firstTypeTabList, 'typeCode')
  },
  mutations: {
    setFirstTypeTabList(state, payload = []) {
      state.firstTypeTabList = payload;
    },
  },
  actions: {
    async fetchFirstTypeTabList({ commit, state }) {
      if (state.firstTypeTabList.length) return;

      try {
        let { data } = await $axios.post(
          `/${process.env.VUE_APP_PROXY_DING_OA}/chairman/file/getFirstTypeTabList`,
          {},
          { type: "form", uselsmyAccount: true }
        );

        commit("setFirstTypeTabList", data);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
